import { Link } from "react-router-dom";
import { siteConfig } from "@/config/site";

const friendLinks = [
  { label: "光影资料馆", href: "https://example.com/archive" },
  { label: "剧集日历", href: "https://example.com/calendar" },
  { label: "独立短片计划", href: "https://example.com/shortfilm" },
  { label: "城市影展", href: "https://example.com/festival" },
  { label: "胶片爱好者社区", href: "https://example.com/filmclub" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 pt-12 md:pt-16 pb-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-500 text-primary-950">
                <i className="ri-sun-foggy-line text-xl" aria-hidden="true"></i>
              </span>
              <div className="flex flex-col leading-tight">
                <span className="font-heading text-xl font-bold text-background-50">{siteConfig.name}</span>
                <span className="text-[10px] tracking-[0.22em] text-primary-200">{siteConfig.englishName}</span>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-primary-100/80">
              {siteConfig.description}
            </p>
            <p className="mt-4 text-xs leading-relaxed text-primary-300/70">
              本站所有影视作品、评分与资讯均为演示内容，不提供在线播放与下载服务。
            </p>
          </div>

          <div className="md:col-span-2">
            <h2 className="text-sm font-medium text-background-50">内容导航</h2>
            <ul className="mt-4 space-y-3 text-sm">
              <li>
                <Link to="/category/movie" className="text-primary-100/80 transition-colors cursor-pointer hover:text-secondary-400">
                  电影
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-primary-100/80 transition-colors cursor-pointer hover:text-secondary-400">
                  电视剧
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-primary-100/80 transition-colors cursor-pointer hover:text-secondary-400">
                  搜索结果
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-100/80 transition-colors cursor-pointer hover:text-secondary-400">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h2 className="text-sm font-medium text-background-50">友情链接</h2>
            <ul className="mt-4 space-y-3 text-sm">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-primary-100/80 transition-colors cursor-pointer hover:text-secondary-400"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h2 className="text-sm font-medium text-background-50">保持联系</h2>
            <p className="mt-4 text-sm leading-relaxed text-primary-100/80">{siteConfig.address}</p>
            <a
              href={`mailto:${siteConfig.contactEmail}`}
              className="mt-3 inline-flex items-center gap-2 text-sm text-secondary-400 transition-colors cursor-pointer hover:text-secondary-300"
            >
              <i className="ri-mail-line" aria-hidden="true"></i>
              {siteConfig.contactEmail}
            </a>
            <div className="mt-5 flex items-center gap-2">
              {[
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-booklet-line", label: "影评专栏" },
              ].map((item) => (
                <span
                  key={item.label}
                  title={item.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-primary-100"
                >
                  <i className={`${item.icon} text-base`} aria-hidden="true"></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800 pt-6 text-xs text-primary-300/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {siteConfig.name} · 光影内容演示站</p>
          <p className="flex flex-wrap gap-x-4 gap-y-2">
            <span>关于我们</span>
            <span>内容声明</span>
            <span>联系方式</span>
          </p>
        </div>
      </div>
    </footer>
  );
}